module.exports = __webpack_public_path__ + "static/media/appsPrize.b1e2c96d.svg";